import {div} from '@xh/hoist/cmp/layout';
import './WidgetToolbarLabel.scss';

export function widgetToolbarLabel(text: string): React.ReactElement {
    return div({className: 'rzx-widget-toolbar-label', items: [text, '\u2022']});
}
